import * as React from 'react';
import IconTransfer from 'design-system/icons/IconTransfer';
import { CardView, SettingsItemNavigate } from 'design-system';
import PayIcon from '../icons/PayIcon';
import RequestIcon from '../icons/RequestIcon';
import { usePayQuickCTAs } from '../hooks/usePayQuickCTAs';
const PayTabQuickCTAs = ({ cardViewStyle }) => {
    const { onPressPay, onPressRequest, onPressTransfer } = usePayQuickCTAs('pay_tab');
    return (<CardView style={cardViewStyle}>
      <SettingsItemNavigate titleFirst title="Pay someone" description="By bank transfer or scan QR code" icon={<PayIcon colorKey="statusNegative"/>} onPress={onPressPay}/>
      <SettingsItemNavigate titleFirst title="Request money" description="Ask someone for money you’re owed" icon={<RequestIcon colorKey="statusPositive"/>} onPress={onPressRequest}/>
      <SettingsItemNavigate titleFirst title="Transfer" description="Move money between your accounts" icon={<IconTransfer colorKey="brand"/>} onPress={onPressTransfer}/>
    </CardView>);
};
export default React.memo(PayTabQuickCTAs);
